module.exports = __webpack_public_path__ + "static/media/gallery-13.652a20ba.jpg";